import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function SearchBar({ onSubmit, loading }) {
  const { t } = useTranslation();
  const [value, setValue] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
    setValue('');
  };

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      <div style={styles.inputWrapper}>
        <span style={styles.icon}>🔍</span>
        <input
          style={styles.input}
          type="text"
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder={t('searchBar.placeholder')}
          disabled={loading}
          autoFocus
        />
      </div>
      <button style={{ ...styles.btn, opacity: loading ? 0.6 : 1 }} type="submit" disabled={loading}>
        {loading ? (
          <span style={styles.spinner} />
        ) : (
          'Research'
        )}
      </button>
    </form>
  );
}

const styles = {
  form: {
    display: 'flex',
    gap: 12,
    width: '100%',
  },
  inputWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    background: 'var(--surface)',
    border: '1px solid var(--border-mid)',
    borderRadius: 10,
    padding: '0 16px',
    transition: 'border-color 0.2s',
  },
  icon: {
    marginRight: 10,
    fontSize: 16,
    opacity: 0.5,
  },
  input: {
    flex: 1,
    background: 'transparent',
    border: 'none',
    outline: 'none',
    color: 'var(--text)',
    fontSize: 15,
    padding: '14px 0',
  },
  btn: {
    background: 'linear-gradient(135deg, #3b82f6, #06b6d4)',
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    padding: '0 28px',
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    whiteSpace: 'nowrap',
    transition: 'opacity 0.2s',
  },
  spinner: {
    display: 'inline-block',
    width: 16,
    height: 16,
    border: '2px solid rgba(255,255,255,0.3)',
    borderTopColor: '#fff',
    borderRadius: '50%',
    animation: 'spin 0.7s linear infinite',
  },
};
